var destination_root = 'https://api.pycrunch.com'
let local_api = 'http://0.0.0.0:8000'
var config = {
  api_root: destination_root,
}
export default config